import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiResponseSafeCheck, ANALYTICS_MESSAGES, useAnalytics } from 'common';
import AuthorizationDetailsTable from './AuthorizationDetailsTable';
import {
  PrintIcon,
  ContactInfo,
  Headings,
  Button,
  Paragraph
} from '@sentara-health/optimahealth_web';
import { GlobalContext } from 'context';

const AuthorizationDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const authDetails = location.state?.authDetails;
  const [phoneNumber, setPhoneNumber] = useState<any>({});
  const { serviceNumber } = useContext(GlobalContext);
  const { trackContentListing } = useAnalytics();

  useEffect(() => {
      if (serviceNumber) {
        setPhoneNumber(JSON.parse(serviceNumber ?? '{}'));
      }

  }, [serviceNumber]);

  const Print = (e: any) => {
    e.preventDefault();
    trackContentListing('1304', ANALYTICS_MESSAGES.AUTHORIZATION_DETAILS_PRINT_CLICK, 1);
    window.print();
  };
  return (
    <div>
      <div className="d-flex not-print align-items-center pt-2 mb-4 pb-2">
        <div className="flex-1">
          <Button
            data-testid="back-to-Authorization"
            className="btn-links link-text arrow-back"
            onClick={(e: { preventDefault: () => void }) => {
              e.preventDefault();
              trackContentListing('1303', ANALYTICS_MESSAGES.AUTHORIZATION_DETAILS_BACK_CLICK, 1);
              navigate('/home/authorizations');
            }}
          >
            {t('authorizationDetails.backToAuthorizationList')}
          </Button>
        </div>
        <div className="d-flex align-items-center">
          <Button
              iconLeft={<PrintIcon fill="primary" />}
              variant="link_btn"
              onClick={Print}
              dataTestId={'print-link'}
            >
              {t('common.print')}
            </Button>          
        </div>
      </div>
      <div className="print mb-4">
        <Headings
          level={1}
          text={t('authorizationDetails.title')}
          dataTestId="authorizationDetailsHeader"
          variant="semiBold"
        />
      </div>
      <AuthorizationDetailsTable authDetails={authDetails} />
      {apiResponseSafeCheck(phoneNumber?.data) ? (
        <div className="mb-4 pb2" data-testid="contact_services">
          <Paragraph text={
            <>
              {t('common.questions')}{' '}
              <ContactInfo
                phoneData={{
                  phone1800: phoneNumber?.data?.benefitPhone1800,
                  phoneLocal: phoneNumber?.data?.benefitPhoneLocal,
                }}
              /></>} variant="regular" data-testid="contactInfo" />

        </div>
      ) : null}
    </div>
  );
};

export default AuthorizationDetails;